import { EditIcon, PreviewIcon } from '@lynx/client-core/src/components/Icons'
import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from 'store'
import { ChannelState } from 'store/channel'
import { ConfigState } from 'store/config'
import { wsMessage } from 'store/messaging'
import { ProfileState } from 'store/profile'
import { SidebarItemProps, SidebarItemState } from './interfaces'
import css from './SidebarItem.module.scss'

class SidebarItem extends React.Component<SidebarItemProps, SidebarItemState> {
	constructor(props: SidebarItemProps) {
		super(props)
		this.state = {
			isWatching: true
		}
	}

	passEdit = (): void => {
		const { name, channelId, userId, wsMessage } = this.props
		const { isWatching } = this.state
		if (name.includes('(admin)')) {
			return
		}

		let watching = isWatching
		if (isWatching) {
			wsMessage({
				channelId,
				type: 'vnc:edit',
				payload: { userId, channelId }
			})
			watching = false
		} else {
			wsMessage({
				channelId,
				type: 'vnc:readonly',
				payload: { userId, channelId }
			})
			watching = true
		}
		this.setState({
			isWatching: watching
		})
	}

	render(): React.ReactNode {
		const { name } = this.props
		const isAdmin = name.includes('(admin)')
		const { isWatching } = this.state

		return (
			<div className={`${css['container']}`} onClick={this.passEdit}>
				<div>{name}</div>
				{!isAdmin && (
					<React.Fragment>
						{isWatching && (
							<div className={css['isWatching']}>
								<PreviewIcon className={css['isWatchingSvg']} />
							</div>
						)}
						{!isWatching && (
							<div className={css['notWatching']}>
								<EditIcon className={css['notWatchingSvg']} />
							</div>
						)}
					</React.Fragment>
				)}
			</div>
		)
	}
}

const mapStateToProps = (state: ApplicationState): { profile: ProfileState; config: ConfigState; channel: ChannelState } => ({
	profile: state.profile,
	config: state.config,
	channel: state.channel
})

export default connect(mapStateToProps, { wsMessage })(SidebarItem)
